__turbopack_context__.v({
  "photo-section": "G0WHga_photo-section",
  "photo-section__actions-container": "G0WHga_photo-section__actions-container",
  "photo-section__photo-container": "G0WHga_photo-section__photo-container",
  "photo-section__photo-cropper": "G0WHga_photo-section__photo-cropper",
  "photo-section__photo-cropper--hidden": "G0WHga_photo-section__photo-cropper--hidden",
  "photo-section__primary-actions-container": "G0WHga_photo-section__primary-actions-container",
  "photo-section__toggled-actions-container": "G0WHga_photo-section__toggled-actions-container",
});
